<template>
  <img
    src="../assets/loading.svg"
    style="background-color: lightslategray; width: 100%"
    alt="Loading SVG"
  />
</template>

<script>
export default {};
</script>

<style>
</style>